<template>
    <div v-if="isShow">
         <Window :id="'newConnectsDevices'" :title="getLanguageStr('word1779','添加新网关/采集器')" ref="Window" >
            <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
                <button class="bdSub boxR hover-bg-highLight" @click="hide">{{$t('cmd85',['取消'])}}</button>
                <button class="functionBtn" type="button" @click="save">{{$t('cmd84',['保存'])}}</button>
            </div>
            <div fillHeight="window,-#newConnectsDevices .head" scroll>
                <div class="w60pct mc mt2x mb1x pb4x">
                  	<div class="pb2x" >{{getLanguageStr('plant368','输入属于该电站的网关/采集器序列号，电站将根据网关/采集器及其子设备来统计电站数据。')}}</div>
                    <AddDevice class="mc mt2x" :id="'connects'" ref="AddDevice" :timezone="timezone"></AddDevice>
                </div>
            </div>
        </Window>
    </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import Window from '@/components/common/ui/WindowForNew.vue'
import Select from '@/components/common/ui/Select.vue'
import InputText from '@/components/common/ui/InputText.vue'
import AddDevice from '@/components/common/AddDevice/AddDevice.vue'
import {PostGateway} from '@/api/maintain/plant/list.js'
export default {
  name: 'AddConnectsDevices',
  components: {Window, Select, InputText, AddDevice},
  props:{
    timezone:{
      type:String,
    }
  },
  data () {
    return {
      stationId: '',
      systemId:'',
      isShow: false
    }
  },
  methods: {
    getLanguageStr,
    show (data) {
      data.systemId?this.systemId=data.systemId:''
      this.isShow = true
      this.$nextTick(() => {
        this.stationId = data.stationId
        this.$refs.Window.show()
        this.$refs.AddDevice.show({
          stationId: data.stationId,
          systemId:this.systemId
        })
      })
    },
    hide () {
      this.$refs.Window.hide()
      setTimeout(() => {
        this.isShow = false
      }, 500)
    },
    save () {
      let command = _.cloneDeep(this.$refs.AddDevice.snList)
      command.forEach(val => {
        delete val.modeChange
        delete val.defaultDiscovery
        if (val.autoDiscovery) {
          val.subDeviceIds = []
        }
      })
      PostGateway(this.stationId,{systemId:this.systemId},command).then(res => {
        this.$emit('refresh')
        this.hide()
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  },
  mounted () {
    lib.fillHeight()
    lib.setScroll($('#newConnectsDevices [scroll]'))
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/AddConnectsDevices.vue